import { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { getMetadata } from 'pages/Cms/helper'
import { formatDate } from 'redesign/shared/date'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { getAudienceName } from 'redesign/shared/utils/get-audience-name/get-audience-name'
import type { TUseNewsletter } from './types'

export const useNewsletterCard = ({ content }: TUseNewsletter) => {
  const { t, language, locale } = useFavurTranslation()
  const metadata = useMemo(() => getMetadata({ content, language }), [content, language])
  const audiences = useMemo(
    () => content.audiences?.map((audience) => getAudienceName({ audience, language, t })).join(','),
    [content.audiences, language, t],
  )
  const dateText = useMemo(
    () =>
      content.sentAt
        ? formatDate({ date: content.sentAt, dateFormat: DATE_FORMAT_VARIANTS.shortWithoutWeekday, locale, t })
        : '-',
    [content.sentAt, locale, t],
  )

  return { metadata, audiences, dateText }
}
